import { GProviderDispatchStatus } from 'src/graphql/types/generated';

// The one status-to-label map for a provider dispatch, shared by the route
// header and the Third Party tab. Once the provider has the route and until a
// GM dispatches, it reads as the courier not being chosen; a dispatched route
// waits on its driver.
export const PROVIDER_DISPATCH_STATUS_LABELS: Record<
  GProviderDispatchStatus,
  string
> = {
  [GProviderDispatchStatus.Pushing]: 'Sending',
  [GProviderDispatchStatus.PushFailed]: 'Send failed',
  [GProviderDispatchStatus.Quoting]: 'Courier not chosen',
  [GProviderDispatchStatus.QuoteFailed]: 'Courier not chosen',
  [GProviderDispatchStatus.Quoted]: 'Courier not chosen',
  [GProviderDispatchStatus.Dispatched]: 'Dispatched',
  [GProviderDispatchStatus.InProgress]: 'In progress',
  [GProviderDispatchStatus.Completed]: 'Completed',
  [GProviderDispatchStatus.Canceled]: 'Canceled',
};

export const providerDispatchStatusLabel = (
  status: GProviderDispatchStatus,
): string => PROVIDER_DISPATCH_STATUS_LABELS[status] ?? status;

// LDS keeps the status when the provider cancels the route and writes this
// prefix to the dispatch's error instead (Burq::EventApplier::CANCELED_ON_BURQ,
// "canceled on Burq"); after it, LDS refuses dispatch and requote.
const CANCELED_ON_PROVIDER_PREFIX = 'canceled on ';

export const isCanceledOnProvider = (
  error: string | null | undefined,
): boolean => !!error && error.startsWith(CANCELED_ON_PROVIDER_PREFIX);
